export default __webpack_public_path__ + "static/media/index.5cd92ea6.less";